import React from "react";
import { IInputProps } from "customHooks/useCompleoReactHookForm/helpers/reactHookFormsHelper";
import RichText from "customHooks/useCompleoReactHookForm/Inputs/RichText/RichText";

const ApplicantOpinionInTheJobEdit = (props: IInputProps) => {
    return <RichText {...props} />;
};

export default ApplicantOpinionInTheJobEdit;
